<script setup lang="ts">
import IconOpenReload from "@/components/icons/IconOpenReload.vue";
import OrdenarIcon from '@/components/icons/OrdenarIcon.vue';
import OrdenarPor from '@/components/icons/OrdenarPor.vue';
import OrdenarPor2 from '@/components/icons/OrdenarPor2.vue';
import FilterOptions from "@/components/mobile/FilterOptions.vue";
import MobileMapOverlay from "../misc/MobileMapOverlay.vue";
import { useObraStore } from "@/stores/obras";
import { useSidebarStore } from "@/stores/sidebar";
useObraStore();
useSidebarStore();
</script>

<template>
    <mobile-map-overlay show-overlay="showOverlay" />
    <div class="fixed-top" id="mobile-search-bar">
        <div class="container-fluid  text-center">
            <div class="d-flex justify-content-center pb-1">
                <div class="col-2 col-sm-1" :class="applyMarginTop">
                    <Transition name="slide-fade">
                        <filter-options @show-options-menu="showOptionsMenu" />
                    </Transition>
                </div>
                <div class="col-8 col-sm-10 mt-4 acima-overlay-mobile" :class="applyElementZIndex">
                    <div class="input-group mt-1   ps-2 pe-1">
                        <input type="text" class="form-control search-field radius-left sombra" id="txtFiltroMobile"
                            placeholder="" v-model="textoBusca" v-on:keyup.enter.prevent="efetuarBusca" />
                        <button class="btn btn-outline-secondary search-button radius-right sombra" type="button"
                            id="buttonSearchMobile" @click="efetuarBusca">
                            <i class="bi bi-search"></i>
                        </button>
                    </div>
                    <div class="w-100 h-100 d-inline-block" @click="hideOverlay"></div>
                </div>
                <div class="col-2 col-sm-1 mt-4 acima-overlay-mobile" :class="applyElementZIndex">
                    <icon-open-reload @click="reload" v-if="$route.name == 'home'" class="mt-2 reload-button " />
                    <div class="ordenacao" v-if="$route.name == 'mobile-lista'">
                        <button class="btn btn-link mobile-button-size" type="button"
                            @click="abrirOrdenacao = !abrirOrdenacao">
                            <ordenar-icon />
                        </button>
                        <ul class="ordenacao-items" v-if="abrirOrdenacao">
                            <li class="no-border">
                                <a href="javascript:void(0);" @click="abrirOrdenacao = !abrirOrdenacao">
                                    <ordenar-icon />
                                </a>
                            </li>
                            <li>
                                <h6 class="ordenacao-titulo"><a @click="direcionarOrdenacao()"> Ordenar por
                                        <ordenar-por v-if="ObraStore.ordenacaoDirecao == 'asc'" />
                                        <ordenar-por2 v-if="ObraStore.ordenacaoDirecao == 'desc'" />
                                    </a></h6>
                            </li>
                            <li :class="{ active: ObraStore.ordenacaoCampo == 'descLote' }"><a href="javascript:void(0);"
                                    @click="ordenarPorDescricao()">Descrição</a>
                            </li>
                            <li :class="{ active: ObraStore.ordenacaoCampo == 'endereco' }"><a href="javascript:void(0);"
                                    @click="ordenarPorEndereco()">Endereço</a>
                            </li>
                            <li :class="{ active: ObraStore.ordenacaoCampo == 'processo' }"><a href="javascript:void(0);"
                                    @click="ordenarPorProcesso()">Processo</a>
                            </li>
                            <li :class="{ active: ObraStore.ordenacaoCampo == 'numContrato' }"><a href="javascript:void(0);"
                                    @click="ordenarPorContrato()">Contrato</a>
                            </li>
                            <li :class="{ active: ObraStore.ordenacaoCampo == 'valorAtual' }"><a href="javascript:void(0);"
                                    @click="ordenarPorValorAtual()">Valor
                                    Atual</a></li>
                            <li class="no-border" :class="{ active: ObraStore.ordenacaoCampo == 'porcentagemExecutada' }"><a
                                    href="javascript:void(0);" @click="ordenarPorExecucao()">%
                                    Executado</a></li>
                        </ul>
                    </div>
                    <div class="w-100 h-100 d-inline-block" @click="hideOverlay"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { mapStores } from "pinia";
import { defineComponent } from "vue";
import { mobileOverlayStore } from '@/stores/mobileOverlay';

export default defineComponent({
    name: "MobileSearchField",
    components: {
        FilterOptions,
    },
    data() {
        return {
            applyMarginTop: 'mt-4',
            applyElementZIndex: '',
            textoBusca: '',
            abrirOrdenacao: false,
        };
    },
    computed: {
        ...mapStores(useObraStore),
        ...mapStores(useSidebarStore),
    },
    methods: {
        showOptionsMenu(showOptions: boolean) {
            this.applyMarginTop = showOptions ? '' : 'mt-4'
            this.applyElementZIndex = showOptions ? 'index-z-mobile-overlay' : ''
            this.toogleOverlay(showOptions)
        },
        toogleOverlay(showOptions: boolean) {
            mobileOverlayStore.showOverlay = showOptions;
        },
        efetuarBusca() {
            this.ObraStore.filtrar(this.textoBusca);
        },
        ordenarPorDescricao() {
            if (this.ObraStore.ordenacaoCampo != "descLote")
                this.ObraStore.ordenar("descLote");
            else
                this.ObraStore.alternarOrdenacao();
        },
        ordenarPorEndereco() {
            if (this.ObraStore.ordenacaoCampo != "endereco")
                this.ObraStore.ordenar("endereco");
            else
                this.ObraStore.alternarOrdenacao();
        },
        ordenarPorProcesso() {
            if (this.ObraStore.ordenacaoCampo != "processo")
                this.ObraStore.ordenar("processo");
            else
                this.ObraStore.alternarOrdenacao();
        },
        ordenarPorContrato() {
            if (this.ObraStore.ordenacaoCampo != "numContrato")
                this.ObraStore.ordenar("numContrato");
            else
                this.ObraStore.alternarOrdenacao();
        },
        ordenarPorValorAtual() {
            if (this.ObraStore.ordenacaoCampo != "valorAtual")
                this.ObraStore.ordenar("valorAtual");
            else
                this.ObraStore.alternarOrdenacao();

        },
        ordenarPorExecucao() {
            if (this.ObraStore.ordenacaoCampo != "porcentagemExecutada")
                this.ObraStore.ordenar("porcentagemExecutada");
            else
                this.ObraStore.alternarOrdenacao();
        },
        direcionarOrdenacao() {
            this.ObraStore.alternarOrdenacao();
        },
        reload() {
            location.reload();
        },
        hideOverlay() {
            mobileOverlayStore.showOverlay = false
            this.SidebarStore.toggleMobile()
        }
    },
});
</script>

<style scoped>
.radius-left {
    border-top-left-radius: 20px !important;
    border-bottom-left-radius: 20px !important;
    opacity: 0.8;
}

.radius-right {
    border-top-right-radius: 20px !important;
    border-bottom-right-radius: 20px !important;
    opacity: 0.8;
}

.mobile-button-size:hover {
    background-color: transparent !important;
}

.index-z-mobile-overlay {
    z-index: -1;
}

.barra-filtro {
    margin-top: .5rem !important;
}

.fixed-top {
    height: 78px;
    /* background-color: #eeeeee;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.1); */
}

.sombra {
    -webkit-box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);
}

.ordenacao {
    position: relative;
    z-index: 2;
}

.ordenacao .btn {
    margin-right: 7px;
}

.ordenacao-items {
    position: absolute;
    inset: 0px 0px auto auto;
    margin-top: -15px;
    padding-top: 17px;
    padding-right: 20px;
    padding-bottom: 10px;
    background: #fff;
    background-clip: padding-box;
    list-style: none;
    display: block;
    text-align: right;
    -webkit-box-shadow: 10px 10px 5px -4px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 10px 10px 5px -4px rgba(0, 0, 0, 0.15);
    box-shadow: 10px 10px 5px -4px rgba(0, 0, 0, 0.15);
}

.ordenacao-items li {
    border-bottom: 1px solid;
    border-color: #d3d3d3;
}

.ordenacao-items .no-border {
    border-bottom: 0px none;
}

.ordenacao-items a {
    display: block;
    width: 100%;
    clear: both;
    font-size: 12px;
    font-weight: 400;
    text-align: inherit;
    text-decoration: none;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
    color: #696969;
    padding: 5px 0px 5px 0px;

}

.ordenacao-items h6.ordenacao-titulo a {
    display: block;
    margin-bottom: 0;
    font-size: 10px;
    font-weight: 700;
    white-space: nowrap;
}

.acima-overlay-mobile {
    z-index: 1100;
}

.ordenacao-items .active a {
    color: #f58634;
}

.reload-button {
    cursor: pointer;
}
</style>
